<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.invoiceNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày - Đến ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    :disabled="disabledDate"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo hóa đơn` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />
          <!-- :show-summary="true" -->
          <!--  h-[750px] -->
          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'700px'"
              :data="rows"
              :border="true"
              :span-method="objectSpanMethod"
              :show-summary="true"
              :summary-method="getSummaries"
            >
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 100"
                :header-align="'left'"
                :align="item.cellClass === 'ag-cell-right' ? 'right' : null"
                :formatter="
                  formatNumberField.includes(item.field) ? displayNumber : null
                "
              >
                <el-table-column
                  v-for="(item1, index1) in item?.children"
                  v-if="item.field === 'revenue'"
                  :key="index1"
                  :prop="item1.field"
                  :label="item1.headerName"
                  :min-width="item1?.minWidth"
                  :header-align="'left'"
                  :align="item1.cellClass === 'ag-cell-right' ? 'right' : null"
                  :formatter="
                    formatNumberField.includes(item1.field)
                      ? displayNumber
                      : null
                  "
                />

                <template v-if="index === 1" #default="scope">
                  <span class="text-[#357456] font-[600] !text-[13px]">{{
                    scope.row.invoice_num
                  }}</span>
                </template>
                <template v-else-if="index === 0" #default="scope">
                  <a
                    style="text-decoration: underline"
                    :href="urlMethod(scope.row)"
                    target="_blank"
                    >{{
                      scope.row.recode_group
                        ? scope.row.recode_group
                        : scope.row.recode
                    }}</a
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <GridVx
            ref="agGrid"
            :columns="columns"
            :rows="rows"
            dom-layout="scroll"
            row-selection="false"
            :suppress-cell-focus="true"
            :is-header-height-setter="true"
            :auto-select-first-row="false"
            :suppress-row-transform="true"
            class="agGrid"
            :pinned-bottom-row-data="pinnedBottomRowData"
          /> -->
        </div>
        <!-- </div> -->
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Số hóa đơn: Khi phát sinh giao dịch và có thanh toán => có hóa đơn
              => hiển thị thông tin từng hóa đơn
            </li>
            <li>Recode: Mã đặt phòng</li>
            <li>Ngày đến/Ngày đi</li>
            <li>Tên khách: Hiển thị tên khách:</li>
            <ul>
              <li>Là tên khách chính khi đặt phòng, phát hành hóa đơn</li>
              <li>Là tên đại lý khi đại lý yêu cầu thanh toán phát hóa đơn</li>
            </ul>
            <li>
              Doanh thu: hiển thị doanh thu của từng loại dịch vụ (Danh sáhc
              dịch vụ được lấy từ cấu hình)
            </li>
            <li>
              Tổng của từng phòng: Hiển thị doanh thu tổng của tất cả các dịch
              vụ trong hóa đơn
            </li>
            <li>
              Tổng: tổng doanh thu của từng loại dịch vụ, thuộc tất cá các hóa
              đơn thuộc phòng và nhà hàng bao gồm cả phí dịch vụ (Đối với nhà
              hàng) và thuế (không tính vé)
            </li>
            <li style="font-weight: bold">Lưu ý:</li>
            <ul>
              <li>
                Với những cột có giá tiền: hiển thị tự động dấu phẩy ngăn cách.
                ví dụ: 1000000 (1 triệu), hiển thị : 1,000,000
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script lang="js">
/* eslint-disable */

import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { ViewInvoiceCellRender } from '@/utils/cellRenders'
import { getInvoiceReport , getInvoiceReportExcel} from '@/api/report_service/datntReport'
import {
  getAgentListForReport
} from '@/api/report_service/takeMoneybyInvoice'
import { getAllHotel } from '@/api/hotel'
import { formatVND } from '@/utils/commonUtils'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}
const cellStyle = params => {
  if (params.data.rowSpan)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
      'border-left': '0.5px solid #ccc',
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const cellStyle1 = () => {
    return {
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ViewInvoiceCellRender,
    CalendarSelect,
    CalendarRange,
    DownloadBtn,
    NoteDialog
  },
  data() {
    return {
      disabledDate: false,
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      searchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        invoiceNum: null,
        hotelIds: [],
        agentId: null
      },
      defaultSearchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        invoiceNum: null,
        hotelIds: [],
        agentId: null
      },

      hotelList: [],
      agentOptions: [],

      // grid
      columns: [
        {
          headerName: 'Nhóm/Khách đoàn',
          field: 'recode_group',
          tooltipField: 'recode_group',
          headerClass: 'header-row-span-2',
          rowSpan: rowSpan,

          cellStyle: cellStyle,
          minWidth: 120,
          maxWidth: 150,
          cellRenderer: 'ViewInvoiceCellRender'

        },
        {
          headerName: 'Số hóa đơn',
          minWidth: 120,
          maxWidth: 150,
          tooltipField: 'invoice_num',
          field: 'invoice_num',
          headerClass: 'header-row-span-2',

        },
        {
          headerName: 'Recode',
          minWidth: 120,
          maxWidth: 150,
          tooltipField: 'recode',
          field: 'recode',
          headerClass: 'header-row-span-2',

        },
        {
          headerName: 'Số phòng',
          minWidth: 100,
          maxWidth: 140,
          tooltipField: 'room_num',
          field: 'room_num',
          headerClass: 'header-row-span-2',

        },
        {
          headerName: 'Thời gian tạo hóa đơn',
          tooltipField: 'create_date',
          field: 'create_date',
          minWidth: 120,
          maxWidth: 180,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Tên khách',
          tooltipField: 'customer_name',
          field: 'customer_name',
          minWidth: 140,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Công ty đại lý du lịch',
          tooltipField: 'agent_name',
          field: 'agent_name',
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          minWidth: 180,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Nguồn',
          field: 'source',
          tooltipField: 'source',
          minWidth: 100,
          maxWidth: 150,
          rowSpan: rowSpan,
          cellStyle: cellStyle,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Doanh thu',
          field: 'revenue',
          children: [
            {
              headerName: 'Tiền phòng',
              field: 'room_money',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.room_money, null),
              valueGetter: params => formatVND(params.data.room_money, null)
            },
            {
              headerName: 'Extra bed',
              field: 'extra_bed',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.extra_bed, null),
              valueGetter: params => formatVND(params.data.extra_bed, null)
            },
            {
              headerName: 'Extra pax',
              field: 'extra_kid',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.extra_kid, null),
              valueGetter: params => formatVND(params.data.extra_kid, null)
            },
            {
              headerName: 'Mini bar',
              field: 'minibar',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.minibar, null),
              valueGetter: params => formatVND(params.data.minibar, null)
            },
            {
              headerName: 'Laundry',
              field: 'laundry',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.laundry, null),
              valueGetter: params => formatVND(params.data.laundry, null)
            },
            {
              headerName: 'Đền bù',
              field: 'compensation',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.compensation, null),
              valueGetter: params => formatVND(params.data.compensation, null)
            },
            // {
            //   headerName: 'Spa',
            //   field: 'spa',
            //   cellClass: 'ag-cell-right',
            //   valueGetter: params => formatVND(params.data.spa, null)
            // },

            {
              headerName: 'Khác',
              field: 'other',
              headerClass: 'last-header-cell-group',
              cellClass: 'ag-cell-right',
              minWidth: 140,
              maxWidth: 140,
              tooltipValueGetter: params => formatVND(params.data.other, null),
              valueGetter: params => formatVND(params.data.other, null)
            }
          ]
        },
        {
          headerName: 'Hoàn tiền',
          field: 'refund',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          cellClass: 'ag-cell-right',
          minWidth: 140,
          maxWidth: 150,
          tooltipValueGetter: params => formatVND(params.data.refund, null),
          valueGetter: params => formatVND(params.data.refund, null)
        },
        {
          headerName: 'Tổng phòng tương ứng',
          field: 'total',
          headerClass: ['header-row-span-2'],
          cellClass: 'ag-cell-right',
          minWidth: 140,
          tooltipValueGetter: params => formatVND(params.data.total, null),
          valueGetter: params => formatVND(params.data.total, null)
        }
      ],
      rows: [

      ],
      pinnedBottomRowData: [

      ],

      // dialog
      dialogNoteVisible: false
    }
  },
  computed: {
    recode() {
      return this.searchParams.recode
    },
    invoiceNum() {
      return this.searchParams.invoiceNum

    },
    formatNumberField() {
      return ['room_money', 'extra_bed', 'extra_kid', 'minibar', 'laundry', 'compensation', 'other', 'refund', 'total']
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.date = null
          this.searchParams.dateTo = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.date = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    },
    invoiceNum: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.date = null
          this.searchParams.dateTo = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.date = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.fnGetAgentOptions()
    await this.fnGetInvoiceReport()
  },

  methods: {
     displayNumber (row, column, cellValue) {
      // console.log('rowwww2,', row, cellValue)
      return this.$displayCurrency(cellValue)
    },
    objectSpanMethod(data) {
      // 0 5 6 7
      if (data.columnIndex == 0 || (data.columnIndex >= 5 && data.columnIndex <= 7)) {
        if (data.row.rowSpan !== undefined)
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSummaries (rawData) {
      const data = this.pinnedBottomRowData[0]

      var bottomRow = []
      bottomRow[1] = 'Tổng'
      bottomRow[8] = data?.room_money
      bottomRow[9] = data?.extra_bed
      bottomRow[10] = data?.extra_kid
      bottomRow[11] = data?.minibar
      bottomRow[12] = data?.laundry
      bottomRow[13] = data?.compensation
      bottomRow[14] = data?.other
      bottomRow[15] = data?.refund
      bottomRow[16] = data?.total
      return bottomRow.map((item) => (!isNaN(item) ? this.$displayCurrency(item) : item))
    },

    urlMethod(params) {
      console.log('params', params)
      // return '#'
      return `/cashier/invoice?id=${
        params.sub_booking_group_id ?? ''
      }&recode=${encodeURIComponent(
        params.recode_group ?? params.recode ?? ''
      )}&name=${encodeURIComponent(
        params.customer_name ?? params.customer_name ?? ''
      )}&company=${encodeURIComponent(
        params.agent_name ?? ''
      )}&address=${encodeURIComponent(
        params.address ?? ''
      )}&from=${encodeURIComponent(
        params.arrive_date ?? params.arrive_date
      )}&to=${encodeURIComponent(
        params.depart_date ?? params.depart_date
      )}&isView=${true}`
    },
    // headerHeightSetter() {
    //   var padding = 40
    //   var height = this.headerHeightGetter() / 2 + padding
    //   this.$refs.agGrid.gridApi.setHeaderHeight(height)
    //   this.$refs.agGrid.gridApi.resetRowHeights()
    // },
    // headerHeightGetter() {
    //   var columnHeaderTexts = [
    //     ...document.querySelectorAll('.ag-header-cell-text')
    //   ]
    //   var clientHeights = columnHeaderTexts.map(
    //     headerText => headerText.clientHeight
    //   )
    //   var tallestHeaderTextHeight = Math.max(...clientHeights)

    //   return tallestHeaderTextHeight
    // },
    onSearch() {
      this.fnGetInvoiceReport()
    },
    onResetSearch() {
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetInvoiceReport()
    },

    // handle call api
    tranferData(data) {
      let newDataRow = []
      data.forEach(data => {
        if (data.data?.length > 0) {
          let dataRowChild = [...data.data]

          dataRowChild[0] = {
            ...dataRowChild[0],
            rowSpan: dataRowChild.length,
            address:data.address,
            sub_booking_group_id: data.sub_booking_group_id,
            agent_name: data.agent_name,
            arrive_date: data.arrive_date,
            depart_date: data.depart_date,
            id: data.sub_booking_group_id,
            recode_group: data.recode_group,
          }
          newDataRow = newDataRow.concat(dataRowChild)
          // data.guest_cancel_detail[0] = {
          //   ...data.guest_cancel_detail[0],
          //   room_booking_code: data.room_booking_code,
          //   rowSpan: data.guest_cancel_detail.length
          // }
          // newDataRow = [...newDataRow, ...data.guest_cancel_detail]
        }
      })
      return newDataRow
    },
    exportExcel() {

      getInvoiceReportExcel(this.searchParams).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'invoice_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },
    async fnGetInvoiceReport() {
      try {
        // const query = {}
        const res = await getInvoiceReport(this.searchParams)


        this.rows = this.tranferData(res.data)
        // this.rows = (res.data)
        const lastRow = res.data.pop()
        this.pinnedBottomRowData = [
          {
            source: 'Tổng',
            minibar: lastRow?.total_minibar,
            laundry: lastRow?.total_laundry,
            compensation: lastRow?.total_compensation,
            karaoke: lastRow?.total_karaoke,
            restaurant: lastRow?.total_restaurant,
            other: lastRow?.total_other,
            total: lastRow?.total_all,
            room_money: lastRow?.total_room,
            extra_bed: lastRow?.total_extra_bed,
            extra_kid: lastRow?.total_extra_kid,
            refund: lastRow?.total_refund
          }
        ]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    setDateRange(range) {

      this.searchParams.date = range.start
      this.searchParams.dateTo = range.end
    },
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions =
        [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    }
  }
}
</script>
<style scoped>
/* .report-table ::v-deep div {
  font-size: 13px !important;
} */
.text-\[\#357456\] {
  color: #357456;
}
.font-\[600\] {
  font-weight: 600;
}
.w-full {
  width: 100%;
}
.h-\[750px\] {
  height: 750px;
}
.overflow-auto {
  overflow: auto;
}
</style>
